module.exports = __webpack_public_path__ + "static/defining-ai-6c151545ebe624c95870e48aeee58e0a.svg";